export var RAGColourValue;
(function (RAGColourValue) {
    RAGColourValue[RAGColourValue["R"] = 32] = "R";
    RAGColourValue[RAGColourValue["A"] = 65] = "A";
    RAGColourValue[RAGColourValue["G"] = 100] = "G";
})(RAGColourValue || (RAGColourValue = {}));
